import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.25 9.05c.753 0 1.375.597 1.375 1.35v9.45h1V12.8c0-.708.551-1.28 1.244-1.344L17 11.45h2.5c.753 0 1.375.597 1.375 1.35v7.05h.5a.75.75 0 0 1 .102 1.493l-.102.007H2.625a.75.75 0 0 1-.102-1.493l.102-.007h.5V16.4c0-.708.551-1.28 1.244-1.344l.131-.006H7c.753 0 1.375.597 1.375 1.35v3.45h1V10.4c0-.708.551-1.28 1.244-1.344l.131-.006zm6.125 3.9h-2.25v6.9h2.25v-6.9zm-12.5 3.599h-2.25v3.301h2.25v-3.301zm6.25-6h-2.25v9.301h2.25v-9.301zm8.791-8.468l.017.018a.754.754 0 0 1 .053.066l-.07-.084a.754.754 0 0 1 .206.447l.003.072v3.6a.75.75 0 0 1-1.493.102l-.007-.102V4.359l-2.939 2.822a2.672 2.672 0 0 1-2.39.682L10.36 6.597a1.187 1.187 0 0 0-1.005.196l-.1.085-4.86 4.665a.75.75 0 0 1-1.113-.999l.075-.083 4.86-4.665a2.677 2.677 0 0 1 2.335-.692l.18.04 4.78 1.227c.359.103.746.03 1.033-.185l.103-.087 2.863-2.75-1.885.001a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .648-.743l.102-.007h3.786l.042.004-.078-.004a.754.754 0 0 1 .53.22l.011.01z' />
  </svg>
);
